import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-appointment-calendar',
  templateUrl: './appointment-calendar.component.html',
  styleUrls: ['./appointment-calendar.component.scss']
})
export class AppointmentCalendarComponent implements OnInit {

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) { }

  slots:any = {status:true, data:[]}
  showPopup:any = false;
  selectedSlot:any = {};
  selectedDate:any = "";
  submitting:any = false;
  acId:any = 21;
  org:any = "";
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.has('org')) {
        this.org = params.get('org');
      }
      
    });

    let context = this;
    var calendarEl = document.getElementById('calendar');
    //@ts-ignore
    var calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: 'dayGridMonth',
        selectable: true,
        headerToolbar: {
            left: '',
            center: '',
            right: 'title,prev,next'
        },
        titleFormat: {
            year: 'numeric',
            month: 'short'
        },
        height: 'auto',
        dateClick: function (info) {
            document.querySelectorAll('.fc-daygrid-day.selected').forEach(function (el) {
                el.classList.remove('selected');
            });

            info.dayEl.classList.add('selected');
             // Log the selected date
            console.log('Selected date:', info.dateStr);
            context.loadAvailability(info.dateStr);

            // Show left panel
            //@ts-ignore
            document.querySelector('.consultant_wrapper').classList.add('show');

            
        }
    });
    calendar.render();

    

  }


  loadAvailability(date){
    this.selectedDate = date;

    if(this.org == "nipmr"){
      this.dataService.getOnlineAvailabilityNipmr(date, this.acId).subscribe( (data: any )=> {
        this.slots = data;
      } );
      
    } else {
      this.dataService.getOnlineAvailability(date, this.acId).subscribe( (data: any )=> {
          this.slots = data;
        } );
    }

    
  }

  selectSlot(slot){
    this.selectedSlot = slot;
    this.showPopup = true;
  }

  submitAppointment(data){
    this.submitting = true;
    data.date = this.selectedDate;
    data.slot_id = this.selectedSlot.id;
    data.ac_id = this.acId;
    
    if(this.org == "nipmr"){
      this.dataService.postNewAppointmentNipmr(data).subscribe( (res:any) => {
        this.submitting = false;
        this.loadAvailability(this.selectedDate);
        this.router.navigate(['/confirmation']);
      });
    } else {
      this.dataService.postNewAppointment(data).subscribe( (res:any) => {
        this.submitting = false;
        this.loadAvailability(this.selectedDate);
        this.router.navigate(['/confirmation']);
      });  
    }

    

  }

}
